import React from "react";
import SentryWrap from "components/Sentry";


import styled from "styled-components";


import WorkSheetTable from "./worksheetTable";



//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

const Wrapper = styled.div`
  height: 100%;
  padding: 20px 0px;
  width: 100%;
`;



const AdminWorkSheet = () => {
 
  return (
    <SentryWrap>
      <Wrapper className={"adminForm"}>
        <WorkSheetTable
          setDataTab
          userloading={false}
          onUpdateOrAdd={() => {}}
        />
      </Wrapper>
    </SentryWrap>
  );
};

export default AdminWorkSheet;
